import React from "react";
import { MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function ListoParaCrear() {
  return <section data-section-id="240804" id="listo-para-crear" className="dark bg-background text-foreground py-24 px-4 sm:px-6 lg:px-8 relative overflow-hidden">
      <div className="max-w-5xl mx-auto">
        <div className="relative rounded-3xl bg-primary/5 border border-primary/10 p-10 md:p-20 text-center overflow-hidden shadow-2xl shadow-primary/10 backdrop-blur-xl">
          {}
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-[600px] h-[400px] bg-primary/30 blur-[120px] rounded-lg pointer-events-none animate-pulse" />

          <div className="relative z-10 flex flex-col items-center">
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold font-default mb-6 tracking-wider text-foreground">
              Tu Visión, Nuestro Sonido
            </h2>
            <p className="text-lg md:text-xl text-muted-foreground mb-10 max-w-2xl mx-auto font-default">
              Damos vida a tus proyectos con música inspiradora y producciones personalizadas que transmiten fe, creatividad y profesionalismo.
            </p>
            
            <Button variant="secondary" size="lg" className="rounded-lg px-8 h-14 text-lg font-bold shadow-lg shadow-secondary/40 transition-transform hover:scale-105 bg-gradient-to-r from-primary to-secondary text-secondary-foreground border-none" asChild>
              <Link to="/ContactPage">
                <MessageCircle className="mr-2 size-6" />
                Agenda una Consulta Gratis
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}